module.exports = __webpack_public_path__ + "img/Calendar Icon.e721b23d.png";